import client from "../client";
import { getFindQrConfig } from "./getFindQrConfig";

const getFindQr = (data?: any) => {
  return client({ ...getFindQrConfig(data.qrCodeId) });
};

export default {
  getFindQr,
};
